class ModalTrigger extends HTMLElement {
  constructor() {
    super();
    this.modalData = JSON.parse(this.querySelector('.js-modal-data').textContent);
  }

  connectedCallback() {
    this.addEventListener('click', this.openModal.bind(this));
  }

  openModal() {
    const popupModal = document.querySelector('popup-modal');
    if (popupModal) {
      popupModal.openModal(this.modalData);
    }
  }
}

if(!customElements.get('modal-trigger')) {
  customElements.define('modal-trigger', ModalTrigger);
}